/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateClaimPayloadDto
 */
export interface CreateClaimPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof CreateClaimPayloadDto
     */
    insuredId: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateClaimPayloadDto
     */
    dateOfLoss: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateClaimPayloadDto
     */
    dateReported: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimPayloadDto
     */
    claimsHandler: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimPayloadDto
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimPayloadDto
     */
    causeOfLoss: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimPayloadDto
     */
    catCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimPayloadDto
     */
    subClass: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimPayloadDto
     */
    lossLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimPayloadDto
     */
    status: CreateClaimPayloadDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimPayloadDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimPayloadDto
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimPayloadDto
     */
    lossDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimPayloadDto
     */
    lineOfBusiness: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateClaimPayloadDto
     */
    fileIds?: Array<string>;
}


/**
 * @export
 */
export const CreateClaimPayloadDtoStatusEnum = {
    PreCautionary: 'Pre-cautionary',
    Registered: 'Registered',
    InProgress: 'In-progress',
    Closed: 'Closed'
} as const;
export type CreateClaimPayloadDtoStatusEnum = typeof CreateClaimPayloadDtoStatusEnum[keyof typeof CreateClaimPayloadDtoStatusEnum];


/**
 * Check if a given object implements the CreateClaimPayloadDto interface.
 */
export function instanceOfCreateClaimPayloadDto(value: object): value is CreateClaimPayloadDto {
    if (!('insuredId' in value) || value['insuredId'] === undefined) return false;
    if (!('dateOfLoss' in value) || value['dateOfLoss'] === undefined) return false;
    if (!('dateReported' in value) || value['dateReported'] === undefined) return false;
    if (!('claimsHandler' in value) || value['claimsHandler'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('causeOfLoss' in value) || value['causeOfLoss'] === undefined) return false;
    if (!('catCode' in value) || value['catCode'] === undefined) return false;
    if (!('subClass' in value) || value['subClass'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('lineOfBusiness' in value) || value['lineOfBusiness'] === undefined) return false;
    return true;
}

export function CreateClaimPayloadDtoFromJSON(json: any): CreateClaimPayloadDto {
    return CreateClaimPayloadDtoFromJSONTyped(json, false);
}

export function CreateClaimPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClaimPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'insuredId': json['insuredId'],
        'dateOfLoss': (new Date(json['dateOfLoss'])),
        'dateReported': (new Date(json['dateReported'])),
        'claimsHandler': json['claimsHandler'],
        'currency': json['currency'],
        'causeOfLoss': json['causeOfLoss'],
        'catCode': json['catCode'],
        'subClass': json['subClass'],
        'lossLocation': json['lossLocation'] == null ? undefined : json['lossLocation'],
        'status': json['status'],
        'city': json['city'],
        'country': json['country'],
        'lossDescription': json['lossDescription'] == null ? undefined : json['lossDescription'],
        'lineOfBusiness': json['lineOfBusiness'],
        'fileIds': json['fileIds'] == null ? undefined : json['fileIds'],
    };
}

export function CreateClaimPayloadDtoToJSON(json: any): CreateClaimPayloadDto {
    return CreateClaimPayloadDtoToJSONTyped(json, false);
}

export function CreateClaimPayloadDtoToJSONTyped(value?: CreateClaimPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insuredId': value['insuredId'],
        'dateOfLoss': ((value['dateOfLoss']).toISOString()),
        'dateReported': ((value['dateReported']).toISOString()),
        'claimsHandler': value['claimsHandler'],
        'currency': value['currency'],
        'causeOfLoss': value['causeOfLoss'],
        'catCode': value['catCode'],
        'subClass': value['subClass'],
        'lossLocation': value['lossLocation'],
        'status': value['status'],
        'city': value['city'],
        'country': value['country'],
        'lossDescription': value['lossDescription'],
        'lineOfBusiness': value['lineOfBusiness'],
        'fileIds': value['fileIds'],
    };
}

